import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { humanizarMensagemErro } from '../common/utils/erroMensagemUtils';

const TOP_N = 10;
const SSAT_BLUE = '#3c8dbc';
const SSAT_BLUE_SOFT = 'rgba(60, 141, 188, 0.78)';
const SSAT_BLUE_OTHERS = 'rgba(60, 141, 188, 0.45)';

function formatChartLabel(mensagem) {
  if (!mensagem || mensagem === 'Outros') {
    return mensagem;
  }
  return humanizarMensagemErro(mensagem) || mensagem;
}

function buildChartData(listErros) {
  const aggregated = {};

  (listErros || []).forEach(item => {
    const raw = item.mensagem || 'Sem mensagem';
    const label = formatChartLabel(raw);
    aggregated[label] = (aggregated[label] || 0) + (parseInt(item.quantidade, 10) || 0);
  });

  const sorted = Object.entries(aggregated)
    .map(([mensagem, quantidade]) => ({ mensagem, quantidade }))
    .sort((a, b) => b.quantidade - a.quantidade);

  if (sorted.length === 0) {
    return { empty: true, chartData: null, fullLabels: [] };
  }

  let items = sorted;
  if (sorted.length > TOP_N) {
    const top = sorted.slice(0, TOP_N);
    const othersSum = sorted.slice(TOP_N).reduce((sum, item) => sum + item.quantidade, 0);
    items = [...top];
    if (othersSum > 0) {
      items.push({ mensagem: 'Outros', quantidade: othersSum, isOthers: true });
    }
  }

  const fullLabels = items.map(item => item.mensagem);
  const values = items.map(item => item.quantidade);

  return {
    empty: false,
    fullLabels,
    chartData: {
      labels: fullLabels,
      datasets: [
        {
          label: 'Quantidade',
          data: values,
          backgroundColor: items.map(item => (item.isOthers ? SSAT_BLUE_OTHERS : SSAT_BLUE_SOFT)),
          borderColor: items.map(() => SSAT_BLUE),
          borderWidth: 1,
          hoverBackgroundColor: SSAT_BLUE,
        },
      ],
    },
  };
}

const chartOptions = fullLabels => ({
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 12,
      right: 18,
      bottom: 8,
      left: 8,
    },
  },
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          precision: 0,
          fontColor: '#64748b',
          fontSize: 12,
          padding: 8,
        },
        gridLines: {
          color: 'rgba(148, 163, 184, 0.20)',
          zeroLineColor: 'rgba(60, 141, 188, 0.35)',
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          fontColor: '#475569',
          fontSize: 11,
          padding: 8,
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false,
        },
        gridLines: {
          color: 'rgba(226, 232, 240, 0.65)',
          drawBorder: false,
        },
        categoryPercentage: 0.72,
        barPercentage: 0.86,
      },
    ],
  },
  tooltips: {
    enabled: true,
    mode: 'nearest',
    intersect: true,
    backgroundColor: 'rgba(15, 23, 42, 0.92)',
    titleFontStyle: '600',
    titleFontSize: 12,
    titleFontColor: '#f8fafc',
    bodyFontSize: 12,
    bodyFontColor: '#e2e8f0',
    borderColor: 'rgba(148, 163, 184, 0.35)',
    borderWidth: 1,
    cornerRadius: 8,
    xPadding: 12,
    yPadding: 10,
    caretPadding: 8,
    callbacks: {
      title(tooltipItems) {
        const index = tooltipItems[0].index;
        return fullLabels[index] || tooltipItems[0].xLabel;
      },
      label(tooltipItem) {
        return `Quantidade: ${tooltipItem.yLabel}`;
      },
    },
  },
});

class GraficoErroGeral extends Component {
  render() {
    const { empty, chartData, fullLabels } = buildChartData(this.props.listErros);

    if (empty) {
      return (
        <div className="erro-geral-chart-empty">
          <i className="fa fa-chart-bar" />
          <h4>Nenhuma notificação no período</h4>
          <p>Altere as datas ou os filtros para visualizar o gráfico.</p>
        </div>
      );
    }

    return (
      <div className="erro-geral-chart-canvas">
        <Bar data={chartData} options={chartOptions(fullLabels)} />
      </div>
    );
  }
}

export default GraficoErroGeral;
